<template>
  <v-dialog v-model="myValue" persistent max-width="760">
    <v-card>
      <v-card-title class="headline">申请回收</v-card-title>
      <v-card-text>
        <v-form v-model="valid" ref="form">
          <v-row style="margin-top: 30px" no-gutters>
            <v-col cols="auto" class="text-subtitle-1"
              >本次剩余样本回收寄送信息如下：</v-col
            >
          </v-row>
          <v-row style="margin-top: 24px" no-gutters class="px-5">
            <v-col cols="12">
              <v-text-field
                v-model="formData.addressee"
                label="收件人"
                :rules="addresseeRules"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters class="px-5">
            <v-col cols="12">
              <v-text-field
                v-model="formData.mobile"
                label="联系电话"
                :rules="mobileRules"
                maxlength="11"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters class="px-5">
            <v-col cols="12">
              <v-text-field
                v-model="formData.address"
                label="寄送地址"
                :rules="addressRules"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row style="color:#ff4d4f; font-weight: 700;" no-gutters>
            <v-col cols="auto" class="text-subtitle-1"
              > *感谢选择我司检测服务！返样涉及干冰我司已免费为您提供，快递为顺丰到付，请知悉。
              </v-col
            >
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="darken-1" @click="myValue = false">取消</v-btn>
        <v-btn color="primary darken-1" @click="onRefOk">提交</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { asgLtcHandleSample } from "@/plugins/api";
import { mobile } from "@/plugins/rules";
export default {
  components: {},
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    sendParams: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onRefOk() {
      const result = this.$refs.form.validate();
      if (!result) return;
      if (this.myItem?.type === "batchRetrive") {
        //批量回收
        const params = this.myItem?.data.map((item) => {
          return {
            projectNo: item.projectcode,
            type: "1", //余样回收类型；1：回收。2：销毁。
            addressee: this.formData.addressee,
            mobile: this.formData.mobile,
            address: this.formData.address,
          };
        });
        asgLtcHandleSample(params).then(({ data }) => {
          if (data) {
            this.$message.success("批量回收成功。");
            this.myValue = false;
            this.$emit("query");
          }
        });
      } else {
        //单个回收
        this.formData.projectNo = this.myItem.projectcode;
        asgLtcHandleSample([this.formData]).then(({ data }) => {
          if (data) {
            this.$message.success("申请回收成功。");
            this.myValue = false;
            this.$emit("query");
          }
        });
      }
    },
    //编辑数据初始化
    initUpdate() {
      this.formData.addressee = this.sendParams.addressee;
      this.formData.mobile = this.sendParams.mobile;
      this.formData.address = this.sendParams.address;
    },
  },
  data() {
    return {
      formData: {
        projectNo: "",
        type: "1", //余样回收类型；1：回收。2：销毁。
        addressee: "",
        mobile: "",
        address: "",
      },
      valid: false,
      addresseeRules: [(v) => !!v || "收件人必填"],
      mobileRules: [(v) => !!v || "联系电话必填", mobile()],
      addressRules: [(v) => !!v || "寄送地址必填"],
    };
  },
  computed: {
    myItem() {
      return this.item;
    },
    myValue: {
      get() {
        if (this.value) {
          this.initUpdate();
        }
        return this.value;
      },
      set(val) {
        if (!val) {
          this.formData.addressee = "";
          this.formData.mobile = "";
          this.formData.address = "";
          this.$refs.form.resetValidation();
        }
        this.$emit("input", val);
      },
    },
  },
  watch: {
  },
};
</script>
